import React, { useState } from 'react';
import {
  FDAccordion, FDAccordionDetails, FDAccordionTitle, FDBodyText, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';
import { HelpTextItem } from './HelpTextItem';

export const HelpTextSection = ({ collection }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <FDAccordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
      <FDAccordionTitle {...dataAttrs('risk-tolerance-help-text')}>
        <FDBodyText value={'What does this mean?'} />
      </FDAccordionTitle>
      <FDAccordionDetails>
        <FDStack direction={'column'} spacing={1}>
          {collection.resources().list().map((r) => (
            <HelpTextItem resource={r} key={r.id()} />
          ))
          }
        </FDStack>
      </FDAccordionDetails>
    </FDAccordion>
  );
};

HelpTextSection.propTypes = {
  collection: PropTypes.object.isRequired,
};
